module.exports = __webpack_public_path__ + "img/icon-table.976a9a76.svg";